import { render, staticRenderFns } from "./ViewReceptions.vue?vue&type=template&id=495accea&scoped=true"
import script from "./ViewReceptions.vue?vue&type=script&lang=js"
export * from "./ViewReceptions.vue?vue&type=script&lang=js"
import style0 from "./ViewReceptions.vue?vue&type=style&index=0&id=495accea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495accea",
  null
  
)

export default component.exports